import { Box, styled, Typography } from "@mui/material";

import gridBackgroundImage from "@/assets/images/background/grid.svg";

import AuthenticationContent from "../components/AuthenticationContent";

export const LinkExpiredContainer = styled(Box)(() => ({
  minHeight: "100vh",
  background: `linear-gradient(125.42deg, rgba(91, 196, 255, 0.08) 0%, rgba(144, 66, 219, 0.08) 82.83%), linear-gradient(0deg, #F9F9F9, #F9F9F9)`,
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "24px",
}));

export const LinkExpiredImage = styled(Box)(() => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: `url(${gridBackgroundImage})`,
  backgroundSize: "auto 90%",
  backgroundPosition: "top",
  backgroundRepeat: "no-repeat",
}));

export const LinkExpiredTitle = styled(Typography)(({ theme }) => ({
  fontSize: "32px",
  fontWeight: 600,
  lineHeight: "39px",
  color: theme.palette.text.primary,
  position: "absolute",
  top: "36px",
  left: "56px",
  textTransform: "uppercase",
}));

export const AuthenticationLinkExpiredContent = styled(AuthenticationContent)(() => ({
  transform: "translateY(40%)",
}));
